import React from 'react';
import { Card } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

const PostSettings: React.FC = () => {
  return (
    <Card className="p-6">
      <h2 className="text-xl font-semibold mb-6">Post Preferences</h2>
      
      <div className="space-y-6">
        {/* Auto Archive Settings */}
        <div>
          <h3 className="text-lg font-medium mb-4">Auto Archive</h3>
          <div className="space-y-3">
            <div className="space-y-2">
              <Label htmlFor="auto-archive">Auto archive posts after</Label>
              <Select defaultValue="30">
                <SelectTrigger id="auto-archive" className="w-full">
                  <SelectValue placeholder="Select days" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="7">7 days</SelectItem>
                  <SelectItem value="14">14 days</SelectItem>
                  <SelectItem value="30">30 days</SelectItem>
                  <SelectItem value="60">60 days</SelectItem>
                  <SelectItem value="90">90 days</SelectItem>
                  <SelectItem value="never">Never archive</SelectItem>
                </SelectContent>
              </Select>
            </div>
          </div>
        </div>
        
        {/* Default Platform */}
        <div>
          <h3 className="text-lg font-medium mb-4">Default Platform</h3>
          <div className="space-y-2">
            <Label htmlFor="default-platform">When creating a new post</Label>
            <Select defaultValue="x">
              <SelectTrigger id="default-platform" className="w-full">
                <SelectValue placeholder="Select platform" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="x">X / Twitter</SelectItem>
                <SelectItem value="linkedin">LinkedIn</SelectItem>
                <SelectItem value="facebook">Facebook</SelectItem>
                <SelectItem value="instagram">Instagram</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>
        
        {/* Optimal Posting Times */}
        <div>
          <h3 className="text-lg font-medium mb-4">Optimal Posting Times</h3>
          <div className="space-y-3">
            <div className="flex items-center justify-between">
              <Label htmlFor="use-optimal-times">Use optimal posting times</Label>
              <Switch id="use-optimal-times" defaultChecked={true} />
            </div>
            
            <div className="text-sm text-gray-500">
              When enabled, your scheduled posts will be automatically adjusted to post at times when your audience is most active.
            </div>
          </div>
        </div>
        
        {/* Post Preview */}
        <div>
          <h3 className="text-lg font-medium mb-4">Post Preview</h3>
          <div className="space-y-3">
            <div className="flex items-center justify-between">
              <Label htmlFor="show-previews">Show post previews</Label>
              <Switch id="show-previews" defaultChecked={true} />
            </div>
            
            <div className="text-sm text-gray-500">
              When enabled, preview how your post will look before publishing.
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default PostSettings; 